import { gql } from "@apollo/client";

const DELETE_STRIPE_USER_SOFTLY = gql`
  mutation deleteStripeUserSoftly(
    $agentIdArr: [ID!]!
    $toDelete: Boolean
    $stripe_id: String!
  ) {
    deleteStripeUserSoftly(
      agentIdArr: $agentIdArr
      toDelete: $toDelete
      stripe_id: $stripe_id
    ) {
      success
      error
      result
    }
  }
`;

export default DELETE_STRIPE_USER_SOFTLY;
